export default "__VITE_ASSET__DD4F25mI__"